import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { useConfig } from "@megarax/dev-config";
import { MegaraxWebappContainer } from "@megarax/features";
import { BlikChecksHome } from "@megarax/loyalty-blik-checks-admin";
import { CartPage, CartsHome } from "@megarax/loyalty-carts-admin";
import { AccountPage, AccountsHome } from "@megarax/loyalty-cash-rewards-accounts-admin";
import { CodeGenerationOrdersHome } from "@megarax/loyalty-code-generation-orders";
import { ListingsPage } from "@megarax/loyalty-listings-admin";
import { OrderFulfillmentHome, OrderPackingPage } from "@megarax/loyalty-order-fulfillment";
import {
  BatchesHome,
  CodeGroupsHome,
  InspectProductCodeView,
  LabelBatchView,
  ProductionBatchView,
  UngroupCodeView,
} from "@megarax/loyalty-product-code-admin";
import { LinePage, QrSyncHome } from "@megarax/loyalty-qr-sync";
import { JSX } from "react";
import { Navigate, Outlet, Route } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

import backgroundImage from "./background_image.png";
import { LoyaltyAdminLogo } from "./LoyaltyAdminLogo";

const loyaltyTheme: Theme = createTheme("328");

export const useLoyaltyRouter = (): JSX.Element => {
  return (
    <>
      <Route
        path="/fulfillment"
        element={
          <ThemeProvider theme={loyaltyTheme}>
            <LoyaltyMegaraxWebappContainer />
          </ThemeProvider>
        }
      >
        <Route path="" element={<Navigate to={getMegaraxPath.uri("megarax://fulfillment/orders")} replace />} />
        <Route path="orders">
          <Route path="" element={<OrderFulfillmentHome />} />
          <Route path="id/:orderId" element={<OrderPackingPage />} />
        </Route>
      </Route>

      <Route
        path="/loyalty"
        element={
          <ThemeProvider theme={loyaltyTheme}>
            <LoyaltyMegaraxWebappContainer />
          </ThemeProvider>
        }
      >
        <Route path="" element={<Navigate to={getMegaraxPath.uri("megarax://loyalty/lines")} replace />} />
        <Route path="code-generation-orders">
          <Route path="" element={<CodeGenerationOrdersHome />} />
        </Route>
        <Route path="code-groups/*" element={<CodeGroupsHome />} />
        <Route path="inspect-code" element={<InspectProductCodeView />} />
        <Route path="inspect-code/id/:codeId" element={<InspectProductCodeView />} />
        <Route path="batches/*" element={<BatchesHome />} />
        <Route path="ungroup-code" element={<UngroupCodeView />} />
        <Route path="label-batches/id/:groupName" element={<LabelBatchView />} />
        <Route path="production-batches/id/:groupName" element={<ProductionBatchView />} />
        <Route path="listings/*" element={<ListingsPage />} />
        <Route path="lines">
          <Route path="" element={<QrSyncHome />} />
          <Route path="id/:lineId" element={<LinePage />} />
        </Route>
        <Route path="carts">
          <Route path="" element={<CartsHome />} />
          <Route path="id/:cartId" element={<CartPage />} />
        </Route>
        <Route path="blik-checks">
          <Route path="" element={<BlikChecksHome />} />
        </Route>
        <Route path="accounts">
          <Route path="" element={<AccountsHome />} />
          <Route path="id/:userId" element={<AccountPage />} />
        </Route>
      </Route>
    </>
  );
};

const LoyaltyMegaraxWebappContainer: React.FC = () => {
  const { config } = useConfig();

  return (
    <MegaraxWebappContainer
      backgroundImageSrc={backgroundImage}
      logo={<LoyaltyAdminLogo width="1em" height="1em" />}
      title="Specjalista"
      subtitle="megarax.net"
      bypassAuth={config.testUser.enabled}
    >
      <Outlet />
    </MegaraxWebappContainer>
  );
};
